/* eslint-disable @typescript-eslint/no-unused-vars */
import IMGUploadComponent from "../../../../../components/IMGUploadComponent";
import ControlledRowTextField from "../../../../../components/ControlledRowTextField";
import { useForm } from "react-hook-form";
import ControlledSelect from "../../../../../components/ControlledSelect";

function CartDetails() {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({});

  const onSubmit = (data: any) => {
  };

  return (
    <div>
      <form className="auth-login-form mt-3" onSubmit={handleSubmit(onSubmit)}>
        <ControlledRowTextField
          label={"Cart Name"}
          inputName={"displayName"}
          inputType={"text"}
          placeholder={"Enter cart name"}
          isRequired={true}
          control={control}
         
        />
        <hr />
        <IMGUploadComponent imageUrl="" onUpload={(e: any) => {}} />
        <hr />
        <ControlledSelect
          label={"Cart is movable or not"}
          inputName={"category"}
          control={control}
          isMulti={true}
          optionsList={[]}
          
        />
        <br />
      </form>
    </div>
  );
}

export default CartDetails;